import React from 'react';

const IconPlusMinus = props => {
  const { type } = props
  if (type === "plus") {

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        fill="none"
        viewBox="0 0 12 12"
      >
        <path
          fill="#19191A"
          d="M6 1.056a.5.5 0 0 1 .5.5V5.5h3.943a.5.5 0 0 1 0 1H6.5v3.944a.5.5 0 1 1-1 0V6.5H1.555a.5.5 0 0 1 0-1H5.5V1.556a.5.5 0 0 1 .5-.5"
        ></path>
      </svg>
    );
  } else if (type === "minus") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        fill="none"
        viewBox="0 0 12 12"
      >
        <path
          fill="#19191A"
          d="M10.443 5.5a.5.5 0 0 1 0 1H1.555a.5.5 0 0 1 0-1z"
        ></path>
      </svg>
    )
  } else return null
};

export default IconPlusMinus;
